import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import NRTButton from '../../../../_common/_buttons/Button'
import MCLoadingOverlay from "../../../../_minha-central/LoadingOverlay"

const ContentSummary = (props) => {

    const {
        typeSummary,
        grade,
        name,
        finished,
        userName,
        minApproval,
        nextContentSummary,
        onNextContentButtonSummary,
        history,
        code,
        downloadCertificate,
        grades,
    } = props


    if (typeSummary === 'module') {


        const userHasBeenApproved = grades.hasUserBeenApprovedInModule(code)
        const grade = grades.getModuleGrade(code).userGrade

        console.log(grade, 'grade')
        return (
            <div className="content-summary">
                {
                    userHasBeenApproved ? <div className={'img-summary success'}/> : <div className={'img-summary fail'}/>
                }

                <div className="description-summary">
                    {!isNaN(grade) && <span><b>Sua nota: {Math.floor(grade)}%</b></span>}
                    {
                        (userHasBeenApproved) ?
                        <Fragment>
                            <span><b>Parabéns, </b><i>{userName}</i></span>
                            <span className="result-message">você concluiu o módulo {name}.</span>
                        </Fragment> :
                            <Fragment>
                                <span><b>Que Pena, </b><i>{userName}</i></span>
                                <span className="result-message">você concluiu o módulo {name} mas não teve um resultado suficiente para ser aprovado.
                                    <br/>
                                    <br/>
                                    Volte nas questões do módulo e tente novamente.
                                </span>
                            </Fragment>
                    }

                    {
                        userHasBeenApproved &&
                        <Fragment>
                            <p> Clique no botão abaixo para continuar seu curso.</p>
                            <NRTButton onClick={() => onNextContentButtonSummary(nextContentSummary)}
                                       style={{background: 'var(--primary-color)', width: '15rem', marginTop: '2rem'}}
                            >
                                {nextContentSummary.finished ? 'Finalizar curso': 'Começar próximo módulo'}
                            </NRTButton>
                        </Fragment>
                    }

                </div>
            </div>
        )
    }


    const contentsSummary = {
        class: <div className="content-summary">
            {
                !!minApproval && !!grade &&
                <Fragment>
                    {grade >= (minApproval * 100) && <div className={'img-summary success'}/>}
                    {(grade < (minApproval * 100)) && <div className={'img-summary fail'}/>}
                </Fragment>
            }
            <Fragment>
                {(!minApproval || !grade) && <div className={'img-summary success'}/>}
            </Fragment>
            <div className="description-summary">
                {!!grade && <span><b>Sua nota: {Math.floor(grade)}%</b></span>}
                {
                    (!minApproval || !grade) &&
                    <Fragment>
                        <span><b>Parabéns, </b><i>{userName}</i></span>
                        <span className="result-message">você concluiu a aula {name}.</span>
                    </Fragment>
                }
                {
                    !!minApproval && !!grade &&
                    <Fragment>
                        {
                            grade >= (minApproval * 100) &&
                            <Fragment>
                                <span><b>Parabéns, </b><i>{userName}</i></span>
                                <span className="result-message">você concluiu a aula {name} e teve um resultado suficiente para ser aprovado.</span>
                            </Fragment>
                        }
                        {
                            (grade < (minApproval * 100)) &&
                            <Fragment>
                                <span><b>Que Pena, </b><i>{userName}</i></span>
                                <span className="result-message">você concluiu a aula {name} mas não teve um resultado suficiente para ser aprovado.</span>
                            </Fragment>
                        }
                    </Fragment>
                }
                {!!grade && <p> Veja abaixo seus resultados na aula. </p>}
                <p> Clique no botão abaixo para continuar seu curso.</p>
                <NRTButton onClick={() => onNextContentButtonSummary(nextContentSummary)}
                           style={{background: 'var(--primary-color)', width: '15rem', marginTop: '2rem'}}
                >
                    { nextContentSummary !== null && nextContentSummary.type === 99 ? 'Ir para resumo do módulo' : 'Ir para próxima aula' }
                </NRTButton>
            </div>
        </div>,

        course: finished ? (<div className="content-summary">
                {
                    !!minApproval && !!grade &&
                    <Fragment>
                        {grade >= (minApproval * 100) && <div className={'img-summary success-course'}/>}
                        {(grade < (minApproval * 100)) && <div className={'img-summary fail'}/>}
                    </Fragment>
                }
                <Fragment>
                    {(!minApproval || !grade) && <div className={'img-summary success-course'}/>}
                </Fragment>
                <div className="description-summary">
                    {!!grade && <span><b>Sua nota: {Math.floor(grade)}%</b></span>}
                    {
                        (!minApproval || !grade) &&
                        <Fragment>
                            <span><b>Parabéns, </b><i>{userName}</i></span>
                            <span className="result-message">você acaba de concluir o curso.</span>
                        </Fragment>
                    }
                    {
                        !!minApproval && !!grade &&
                        <Fragment>
                            {
                                grade >= (minApproval * 100) &&
                                <Fragment>
                                    <span><b>Parabéns, </b><i>{userName}</i></span>
                                    <span className="result-message">você acaba de concluir o curso e teve um resultado suficiente para ser aprovado.</span>
                                </Fragment>
                            }
                            {
                                (grade < (minApproval * 100)) &&
                                <Fragment>
                                    <span><b>Que Pena, </b><i>{userName}</i></span>
                                    <span className="result-message">você acaba de concluir o curso mas não teve um resultado suficiente para ser aprovado..</span>
                                </Fragment>
                            }
                        </Fragment>
                    }
                    {!!grade && <p> Veja abaixo seus resultados obtidos. </p>}
                    {
                        (grades.hasUserBeenApprovedInModule(code)) &&
                        <Fragment>
                            {props.loadingDownload &&
                            <MCLoadingOverlay show={true}/>
                            }
                            <p> Se quiser, faça download de seu certificado.</p>
                            < NRTButton onClick={downloadCertificate}
                                        style={{background: 'var(--primary-color)', width: '15rem', marginTop: '2rem'}}
                            >
                                Baixar Certificado
                            </NRTButton>
                        </Fragment>
                    }
                </div>
            </div>) :
            (<div className="content-summary">
                {
                    !!minApproval && !!grade &&
                    <Fragment>
                        {grade >= (minApproval * 100) && <div className={'img-summary success-course'}/>}
                        {(grade < (minApproval * 100)) && <div className={'img-summary fail'}/>}
                    </Fragment>
                }
                <Fragment>
                    {(!minApproval || !grade) && <div className={'img-summary success'}/>}
                </Fragment>
                <div className="description-summary">
                    {
                        !!grade &&
                        <span><b>Sua nota: {Math.floor(grade)}%</b></span>
                    }
                    {
                        (!minApproval || !grade) &&
                        <Fragment>
                            <span><b>Parabéns, </b><i>{userName}</i></span>
                            <span className="result-message">você concluiu o curso até aqui.</span>
                        </Fragment>
                    }
                    {
                        !!minApproval && !!grade &&
                        <Fragment>
                            {
                                grade >= (minApproval * 100) &&
                                <Fragment>
                                    <span><b>Parabéns, </b><i>{userName}</i></span>
                                    <span className="result-message">você concluiu o curso até aqui e teve um resultado suficiente para ser aprovado.</span>
                                </Fragment>
                            }
                            {
                                (grade < (minApproval * 100)) &&
                                <Fragment>
                                    <span><b>Que Pena, </b><i>{userName}</i></span>
                                    <span className="result-message">você concluiu o curso até aqui mas não teve um resultado suficiente para ser aprovado..</span>
                                </Fragment>
                            }
                        </Fragment>
                    }
                    {
                        !!grade && <p> Veja abaixo seus resultados no módulo. </p>
                    }
                    <p> Fique ligado que em breve novos módulos estarão disponíveis.</p>
                    <NRTButton onClick={() => history.push(`/conta/curso/${code}`)}
                               style={{background: 'var(--secondary-color)', width: '15rem', marginTop: '2rem'}}
                    >
                        Voltar Para Início
                    </NRTButton>
                </div>
            </div>)
    }


    return (
        <div>
            {contentsSummary[typeSummary]}
        </div>
    )
}

ContentSummary.propTypes = {
    typeSummary: PropTypes.string.isRequired,
    grade: PropTypes.number,
    name: PropTypes.string.isRequired,
    courseName: PropTypes.string,
    downloadCertificate: PropTypes.func
}

ContentSummary.defaultProps = {}

export default ContentSummary



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/CourseSummary/ContentSummary/index.js